import { useEffect, useState, useRef } from "react";
import {
  Header,
  Table,
  Segment,
  Icon,
  Input,
  Button,
  Dropdown,
  Popup,
} from "semantic-ui-react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SMALL_GROUPS, DELETE_SMALLGROUP } from "../graphQueries";
import Alert from "../Alert/Alert";
import moment from "moment";
const SmallGroups = (props) => {
  const [initializing, setInit] = useState(true);
  const [sort, setSort] = useState({ column: "created", order: "descending" });
  const [filteredList, setFiltered] = useState([]);
  const [smallGroupsList, setSmallGroupsList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSmallGroup, setSelectedSmallGroup] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [selectedSmallGroups, setSelectedSmallGroups] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [addedSmallGroups, setAddSmallGroups] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [page, setPage] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const [recordsDisplayed, setRecordsDisplayed] = useState(0);

  const clearTimerRef = useRef();

  useEffect(() => {
    console.log(smallGroupsList);
  }, [smallGroupsList]);

  useEffect(() => {
    console.log(filteredList);
  }, [filteredList]);

  useEffect(() => {
    console.log(selectedSmallGroups);
  }, [selectedSmallGroups]);

  useEffect(() => {
    smallGroups();
  }, []);

  // smallGroups query
  const [smallGroups] = useLazyQuery(SMALL_GROUPS, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleSmallGroups_Result(result),
    onError: (error) => handleSmallGroups_Error(error),
  });
  const handleSmallGroups_Result = (result) => {
    if (result.smallGroups && result.smallGroups.length) {
      const smallGroupList = [...result.smallGroups];
      const sorted = smallGroupList.sort((a, b) =>
        (a.smallGroup || "").localeCompare(b.smallGroup || "")
      );
      setSmallGroupsList(sorted);
      setInit(false);
    }
  };
  const handleSmallGroups_Error = (error) => {
    console.log(error);
  };

  const handleSort = (column) => {
    const newOrder = sort.order === "ascending" ? "descending" : "ascending";
    let sortList = [...smallGroupsList];
    if (filteredList && filteredList.length > 0) {
      sortList = [...filteredList];
    }

    if (column === "created" && newOrder === "ascending") {
      sortList.sort((a, b) => (a.created || "").localeCompare(b.created || ""));
    }
    if (column === "created" && newOrder === "descending") {
      sortList.sort((a, b) => (b.created || "").localeCompare(a.created || ""));
    }

    if (column === "firstName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.firstName || "").localeCompare(b.firstName || "")
      );
    }
    if (column === "firstName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.firstName || "").localeCompare(a.firstName || "")
      );
    }

    if (column === "lastName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.lastName || "").localeCompare(b.lastName || "")
      );
    }
    if (column === "lastName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.lastName || "").localeCompare(a.lastName || "")
      );
    }

    if (column === "groupSize" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.groupSize || "").localeCompare(b.groupSize || "")
      );
    }
    if (column === "groupSize" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.groupSize || "").localeCompare(a.groupSize || "")
      );
    }

    if (column === "titleName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.titleName || "").localeCompare(b.titleName || "")
      );
    }
    if (column === "titleName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.titleName || "").localeCompare(a.titleName || "")
      );
    }

    if (column === "circuitName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.circuitName || "").localeCompare(b.circuitName || "")
      );
    }
    if (column === "circuitName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.circuitName || "").localeCompare(a.circuitName || "")
      );
    }

    if (column === "theaterName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.theaterName || "").localeCompare(b.theaterName || "")
      );
    }
    if (column === "theaterName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.theaterName || "").localeCompare(a.theaterName || "")
      );
    }

    if (column === "studioName" && newOrder === "ascending") {
      sortList.sort((a, b) =>
        (a.studioName || "").localeCompare(b.studioName || "")
      );
    }
    if (column === "studioName" && newOrder === "descending") {
      sortList.sort((a, b) =>
        (b.studioName || "").localeCompare(a.studioName || "")
      );
    }

    if (filteredList && filteredList.length > 0) {
      setFiltered(sortList);
    } else {
      setSmallGroupsList(sortList);
    }
    setSort({ column, order: newOrder });
  };

  const handleFilter = (e) => {
    setSearching(true);
    const searchTerm = e.target.value.toUpperCase();
    const filteredArray = smallGroupsList.filter((x) =>
      `${x.firstName} ${x.lastName} ${x.email} ${x.groupSize} ${x.titleName} ${x.circuitName} ${x.theaterName} ${x.studioName}`
        .toUpperCase()
        .includes(searchTerm)
    );
    clearTimeout(clearTimerRef.current);
    clearTimerRef.current = setTimeout(() => {
      setSearching(false);
      if (searchTerm === "") {
        setFiltered([]);
      } else {
        setFiltered(filteredArray);
      }
    }, 1000);
  };

  const clearError = () => {
    setErrorMessage("");
  };

  const handleRefresh = () => {
    smallGroups();
    setInit(true);
  };

  const [deleteSmallGroup] = useMutation(DELETE_SMALLGROUP, {
    onCompleted: (result) => handleDeleteSmallGroup_Result(result),
    onError: (error) => handleDeleteSmallGroup_Error(error),
  });

  const handleDeleteSmallGroup_Result = (result) => {
    console.log(result);
    if (result && result.deleteSmallGroup.status === "succeeded") {
      setSuccessMessage("Deleted successfully.");
      smallGroups();
      resetState();
    } else {
      setErrorMessage(result.message);
    }
  };

  const handleDeleteSmallGroup_Error = (error) => {
    console.log(error);
    setErrorMessage(error.message);
  };

  const handleDelete = () => {
    deleteSmallGroup({
      variables: { smallGroupId: selectedSmallGroup.smallGroupId },
    });
  };

  const resetState = () => {
    setSelectedSmallGroup({});
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 4000);
  };

  const handleChangePage = (direction) => {
    if (direction === "up") {
      setPage(page + 1);
    }
    if (direction === "down") {
      setPage(page - 1);
    }
    const scrollingContainer = document.getElementById("scrollingContainer");
    if (scrollingContainer) {
      scrollingContainer.scrollTo({
        top: 0,
        left: 0,
      });
    }
  };

  const getPages = () => {
    let arrayOfPages = [];
    let count = 1;
    while (count <= numPages) {
      const obj = {
        text: count,
        value: count,
      };
      arrayOfPages.push(obj);
      count++;
    }
    // console.log(arrayOfPages);
    return arrayOfPages;
  };

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const SmallGroupsList = () => {
    let smallGroups = smallGroupsList;
    if (filteredList && filteredList.length > 0) {
      smallGroups = filteredList;
    }
    setNumPages(Math.ceil(smallGroups.length / 50));
    setRecordsDisplayed(smallGroups.length);
    const paged = paginate(smallGroups, 50, page);
    return paged.map((item, index) => {
      return (
        <Table.Row
          onClick={() => setSelectedSmallGroup(item)}
          active={item.smallGroupId === selectedSmallGroup.smallGroupId}
          key={index}
        >
          <Table.Cell>{moment(item.created).format("LLL")}</Table.Cell>
          <Table.Cell>{item.firstName}</Table.Cell>
          <Table.Cell>{item.lastName}</Table.Cell>
          <Table.Cell>{item.email}</Table.Cell>
          <Table.Cell>{item.groupSize}</Table.Cell>
          <Table.Cell>{item.titleName}</Table.Cell>
          <Table.Cell>{item.circuitName}</Table.Cell>
          <Table.Cell>{item.theaterName}</Table.Cell>
          <Table.Cell>{item.studioName}</Table.Cell>
          <Table.Cell>{item.destination}</Table.Cell>
        </Table.Row>
      );
    });
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 50px)",
        width: "100vw",
        position: "absolute",
        top: "50px",
      }}
    >
      {successMessage && <Alert successMessage={successMessage} />}
      {errorMessage && <Alert failed successMessage={errorMessage} />}
      <div
        style={{
          maxWidth: "95%",
          maxHeight: "90%",
          backgroundColor: "#F1F1F1",
          borderRadius: "10px",
          width: "100%",
          padding: "20px",
          zIndex: "1",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.25)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <Button
            icon="refresh"
            style={{ opacity: 0, pointerEvents: "none" }}
          />
          <Header
            style={{
              textAlign: "center",
              margin: "0px",
            }}
            content="Small Groups"
          />
          <Button
            title="Refresh SmallGroups List"
            disabled={initializing}
            loading={initializing}
            icon="refresh"
            // style={{ position: "absolute", right: "5px", top: "5px" }}
            onClick={handleRefresh}
          />
        </div>
        <Input
          style={{ marginBottom: "20px" }}
          placeholder="Search..."
          icon={
            searching ? (
              <Icon loading name="circle notch" />
            ) : (
              <Icon name="search" />
            )
          }
          iconPosition="left"
          onChange={handleFilter}
        />
        <div style={{ overflowY: "auto", maxHeight: "70vh" }}>
          {initializing && (
            <Segment
              placeholder
              style={{
                alignItems: "center",
                backgroundColor: "#F1F1F1",
              }}
            >
              <Header content="Loading SmallGroups..." />
              <Icon size="big" loading name="circle notch" />
            </Segment>
          )}
          {!initializing && (
            <Table
              sortable
              selectable
              style={{
                borderTop: "0px",
                whiteSpace: "nowrap",
              }}
            >
              <Table.Header
                style={{
                  border: "0px",
                  backgroundColor: "#F1F1F1",
                }}
              >
                <Table.Row>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background: sort.column === "created" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "created" ? sort.order : null}
                    onClick={() => handleSort("created")}
                  >
                    Created
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "firstName" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "firstName" ? sort.order : null}
                    onClick={() => handleSort("firstName")}
                  >
                    First Name
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background: sort.column === "lastName" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "lastName" ? sort.order : null}
                    onClick={() => handleSort("lastName")}
                  >
                    Last Name
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background: sort.column === "email" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "email" ? sort.order : null}
                    onClick={() => handleSort("email")}
                  >
                    Email
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "groupSize" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "groupSize" ? sort.order : null}
                    onClick={() => handleSort("groupSize")}
                  >
                    Group Size
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "titleName" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "titleName" ? sort.order : null}
                    onClick={() => handleSort("titleName")}
                  >
                    Title
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background: sort.column === "circuit" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "circuit" ? sort.order : null}
                    onClick={() => handleSort("circuit")}
                  >
                    Circuit
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "theaterName" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "theaterName" ? sort.order : null}
                    onClick={() => handleSort("theaterName")}
                  >
                    Theater
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "studioName" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "studioName" ? sort.order : null}
                    onClick={() => handleSort("studioName")}
                  >
                    Studio
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{
                      position: "sticky",
                      top: 0,
                      borderTop: "1px solid rgba(34,36,38,.15)",
                      background:
                        sort.column === "destination" ? "aliceblue" : "",
                    }}
                    sorted={sort.column === "destination" ? sort.order : null}
                    onClick={() => handleSort("destination")}
                  >
                    ATOM URL
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <SmallGroupsList />
              </Table.Body>
            </Table>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Button
              size="large"
              style={{ marginTop: "20px" }}
              disabled={page === 1}
              icon="left arrow"
              onClick={() => handleChangePage("down")}
            />
            <Dropdown
              style={{ marginRight: "5px" }}
              selection
              compact
              scrolling
              options={getPages()}
              onChange={(e, data) => setPage(data.value)}
              value={page}
            />
            <Button
              size="large"
              style={{ marginTop: "20px" }}
              disabled={page === numPages}
              icon="right arrow"
              onClick={() => handleChangePage("up")}
            />
            <span>
              {page === 1 ? 1 : ((page - 1) * 50 + 1).toLocaleString()} to{" "}
              {page * 50 + 1 > recordsDisplayed
                ? recordsDisplayed.toLocaleString()
                : (page * 50 + 1).toLocaleString()}{" "}
            </span>
            <span>
              <b>({recordsDisplayed.toLocaleString()} total)</b>
            </span>
          </div>
          <Popup
            open={confirmDelete}
            trigger={
              <Button
                style={{ marginTop: "20px" }}
                disabled={Object.keys(selectedSmallGroup).length === 0}
                content="Delete"
                negative
                size="large"
                onClick={() => setConfirmDelete(true)}
              />
            }
            content={
              <div>
                <p>Confirm delete?</p>
                <Button
                  content="Yes"
                  positive
                  onClick={() => {
                    setConfirmDelete(false);
                    handleDelete();
                  }}
                />
                <Button
                  content="No"
                  negative
                  onClick={() => setConfirmDelete(false)}
                />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};
export default SmallGroups;
